export function define<T>(thing: T): T {
    return thing;
}
define.nullable = nullable;

function nullable<T>(): T | null {
    return null;
}
